import React, { ReactNode } from 'react';

import PropTypes from 'prop-types';

import { ArrowRightIcon } from '@adsk/alloy-react-icon';
import { stylePropType, StylableComponent } from '@adsk/alloy-react-theme';

type ActivityValueChangeProps = StylableComponent<HTMLDivElement> & {
  before?: ReactNode;
  after: ReactNode;
};

/**
 * ActivityValueChange component. Describes a single change between before and after values.
 */
const ActivityValueChange = React.forwardRef<
  HTMLDivElement,
  ActivityValueChangeProps
>(({ before, after, style, className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={className}
      css={[
        {
          display: 'flex',
          alignItems: 'center',
          minHeight: 28,
          flexWrap: 'wrap',
          rowGap: 4,
        },
        style,
      ]}
      {...props}
    >
      {before && (
        <div
          dir="auto"
          css={[
            {
              marginRight: 7,
            },
          ]}
        >
          {before}
        </div>
      )}
      <div
        css={[
          {
            display: 'flex',
            alignItems: 'center',
          },
        ]}
      >
        {before && (
          <ArrowRightIcon
            style={{
              marginRight: 7,
              minWidth: 24,
              alignSelf: 'flex-start',
            }}
          />
        )}
        <div dir="auto">{after}</div>
      </div>
    </div>
  );
});

ActivityValueChange.displayName = 'ActivityValueChange';

ActivityValueChange.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** The value to render before change */
  before: PropTypes.any,
  /** The value to render after change */
  after: PropTypes.any.isRequired,
};

export default ActivityValueChange;
